import { useEffect, useState } from 'react';

const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Plays a one-shot timeline and returns elapsed seconds, capped at `duration`.
 * Reduced-motion users get the final frame immediately.
 */
export const useHeroTimeline = (duration: number): number => {
  const [elapsed, setElapsed] = useState<number>(() =>
    prefersReducedMotion() ? duration : 0
  );

  useEffect(() => {
    if (prefersReducedMotion()) {
      setElapsed(duration);
      return;
    }

    let frameId = 0;
    let startedAt: number | null = null;

    const tick = (now: number): void => {
      if (startedAt === null) startedAt = now;
      const seconds = (now - startedAt) / 1000;
      setElapsed(Math.min(seconds, duration));
      if (seconds < duration) frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [duration]);

  return elapsed;
};
